import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import {  useEffect, useMemo, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import ReactDataTableModifiable from "components/DataTable/ReactDataTableModifiable";
import ReactDataTableDisplay from "components/DataTable/ReactDataTableDisplay";
import { delConfirm, isEmpty, modConfirm, saveConfirm } from "js/common";
import { getUserInfo } from "api/commonUtil";

/**
 * 지점 옵션 재고 수정 팝업
 */
function BranchOptionStockCntModModal (props) {

	const { isOpen, onClose, initData, modalId, title } = props;
	// const [ origData, setOrigData ] = useState({});	// return 형태가 nextOptionId와 데이터 목록으로 구성되어 있음. 이거 전체를 담는 Object
	const [ data, setData ] = useState([]);	// 데이터 목록만 담을 Object
	const [ dataSend, setDataSend ] = useState({});	// 테이블에서 넘어온 데이터
	
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "No", col : "ordr", cellWidth: "30", },
		{ header : "ID", col : "id", cellWidth: "50", },
		{ header : "지점ID", col : "branchId", cellWidth: "100"},
		{ header : "재고", col : "stockQuantity", cellWidth: "100", type: "number", mod: true},
		{ header : "옵션가", col : "price", cellWidth: "100", type: "text" },
		{ header : "사용여부", col : "usable", cellWidth : "100"},
	], []);

	useEffect(() => {
		if(!isOpen) {
			setData([]);
			
			return;
		};
		
		if(isOpen && initData && initData.channelProductNo) getBranchOptionData(initData);

	}, [isOpen, initData]);
	
	// 기존 정보 조회
	const getBranchOptionData = async (productData) => {
		// 원래 페이징이 있는데 우리는 개수가 많지 않아서 그냥 가는걸로...
		const result = await sendGet("/api/mgmt/product/branchOption/" + productData.channelProductNo, {});
		if(result.respCode == "SUCCESS") {
			// setData(result.data);
			
			if(result.data == null || result.data.options == null) {
				setData([]);
				return;
			}

			let ordrData = result.data.options;
			// 지점ID가 있으면 해당 지점것만 표시
			const branchId = getUserInfo().branchId;
			if(branchId != null) {
				ordrData = ordrData.filter(d => d.branchId === branchId);
			}
			ordrData = ordrData.map((d, idx) => ({...d, ordr: idx+1}));

			setData(ordrData);
		} else {
			alert("지점 옵션 조회 실패");
			return;
		}
	}

	// 재고 저장
	const saveStockCnt = async () => {

		if(isEmpty(dataSend[0].stockQuantity)) {
			alert("재고를 입력해 주세요");
			return;
		}

		if(!modConfirm()) return;

		const result = await sendPut("/api/mgmt/product/branchOption/" + initData.channelProductNo + "/stockCnt", dataSend[0]);
		if(result.respCode === "SUCCESS") {
			alert("저장 되었습니다.");
			getBranchOptionData(initData);
		}
	}

	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "1000px", height: "600px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="table-buttons mg-t-10 mg-b-10">
								<BasicButton label="저장" className="btn-save" onClick={() => saveStockCnt(true)} />
							</div>
							<ReactDataTableModifiable
								columns={columns}
								customDatas={data}
								hideCheckBox={true}
								percentageWidth={true}
								maxHeight="250px"
								dataSend={data => setDataSend(data)}
							/>
								
						</div>

						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="닫기" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								{/* <BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} /> */}
							</div>
						</div>

					</div>

				</div>
			</div>
		</ReactModal>
	);
}

export default BranchOptionStockCntModModal;
